import { DOCUMENT } from "@angular/common";
import { inject, InjectionToken } from "@angular/core";

export const THE_DOCUMENT = new InjectionToken<Document>(
  'THE_DOCUMENT',
  { providedIn: 'root', factory: () => inject(DOCUMENT) }
);
